export const getIsoDate = (date: Date) => {
    let year = date.getFullYear();
    let month = String(date.getMonth() + 1).padStart(2, "0");
    let day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

export const ddMmYyyyToIsoDate = (date: string) => {
    let ddmmyyyyRegex = /^\d{2}-\d{2}-\d{4}$/;
    if (!ddmmyyyyRegex.test(date)) return date;

    let [day, month, year] = date.split("-");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
}

export const getDateFromIsoDateTime = (date: string) => {
    if (date.length > 10) {
        return date.slice(0, 10);
    }
    return date;
}

export const isDefaultDotNetDate = (date: string | null) => {
    return date === "0001-01-01T00:00:00" || date === "0001-01-01";
}

export const getDateFromDaysOffset = (daysOffset: number) => {
    let date = new Date();
    date.setDate(date.getDate() + daysOffset);
    return getIsoDate(date);//YYYY-MM-DD
}